(function(){
  var timer;
  function shuffle(items){
    for(var i=items.length-1;i>0;i--){
      var j=Math.floor(Math.random()*(i+1));
      var temp=items[i];items[i]=items[j];items[j]=temp;
    }
    return items;
  }
  function fill(slot,item,index){
    if(!slot||!item)return;
    var image=slot.querySelector('img');
    var title=slot.querySelector('[data-bh-title]');
    slot.href=item.dataset.url;
    image.src=item.dataset.image;
    image.alt=item.dataset.title;
    title.textContent=item.dataset.title;
    slot.hidden=false;
    window.setTimeout(function(){slot.classList.add('is-loaded');},index*65);
  }
  function initialize(){
    if(timer){window.clearInterval(timer);timer=null;}
    document.querySelectorAll('[data-bh-page]').forEach(function(root){
      var options=shuffle([].slice.call(root.querySelectorAll('[data-bh-option]')));
      var slots=[].slice.call(root.querySelectorAll('[data-bh-slot]'));
      var cursor=0;
      if(!options.length)return;
      function show(){
        slots.forEach(function(slot){slot.classList.remove('is-loaded');});
        window.setTimeout(function(){
          slots.forEach(function(slot,index){fill(slot,options[(cursor+index)%options.length],index);});
          cursor=(cursor+slots.length)%options.length;
        },180);
      }
      show();
      if(options.length>slots.length&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        timer=window.setInterval(show,6500);
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
